import React from 'react'
import './index.css'

/**
 * 车辆选择器底部弹窗组件
 * @param {Array} vehicles - 车辆列表
 * @param {boolean} visible - 是否可见
 * @param {Function} onSelect - 选中车辆回调
 * @param {Function} onClose - 关闭弹窗回调
 */
export default function VehiclePicker({ vehicles, visible, onSelect, onClose }) {
    if (!visible) return null

    return (
        <div className="vehicle-picker-overlay" onClick={onClose}>
            <div className="vehicle-picker-sheet" onClick={(e) => e.stopPropagation()}>
                <div className="picker-header">
                    <span className="picker-title">选择车辆</span>
                    <span className="picker-close" onClick={onClose}>✕</span>
                </div>
                <div className="picker-body">
                    {vehicles && vehicles.map((v) => (
                        <div
                            key={v.applicationId}
                            className="picker-item"
                            onClick={() => {
                                onSelect(v)
                                onClose()
                            }}
                        >
                            <span className="picker-plate">{v.plateNumber}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
